/**
 * Copyright ©2023 Drivepoint
 */

import Logger from "./logger/Logger";

const logger = Logger.logger;

export default class Template {

  static parse(template: string, data?: any): any {
    const globals: any = {window: {}, document: {}, globalThis: {}, data: data};
    const body: string[] = [
      `${Object.keys(globals).map(it => `const ${it}=${JSON.stringify(globals[it])}`).join(";")}`,
      "return `" + template + "`;"
    ];
    try {
      return Function(body.join(";"))();
    } catch (error: any) {
      logger.error(template, data, error.message);
      return template;
    }
  }

}
